module.exports = __webpack_public_path__ + "static/media/Image_register.610935ea.png";